
import { CategoryDto, LibraryDto } from '@hem/portal-gateway-axios'

import { getAxios, getAxiosV2 } from './axios-instance'
import APIS from './constants'


export const getAllLibraries = async () => {
  try {
    return await getAxios()
      .get(APIS.libraries)
      .then((response) => {
        return response.data.data as Array<LibraryDto>
      })
  } catch (error) {
    return []
  }
}

export const getAllCategories = async () => {
  try {
    return await getAxios()
      .get(APIS.categories)
      .then((response) => {
        return response.data.data as Array<CategoryDto>
      })
  } catch (error) {
    return []
  }
}

export const deleteCategory = async (id: string) => {
  try {
    return await getAxios().delete(`${APIS.categories}/${id}`)
  } catch (error) {
    return error
  }
}

export const addNewCategory = (name: string) => {
  return getAxios().post(APIS.categories, {
    name,
  })
}

export const updateCategory = (id: string, name: string) => {
  return getAxios().put(`${APIS.categories}/${id}`, {
    name,
  })
}

export const getLibrary = async (libraryId: string) => {
  try {
    return await getAxios()
      .get(`${APIS.libraries}/${libraryId}`)
      .then((response) => response.data.data)
  } catch (error) {
    return error
  }
}

export const getAssignmentInLibrary = async (libraryId: string) => {
  try {
    return await getAxiosV2()
      .get(`${APIS.libraries}/${libraryId}/my-assignment`)
      .then((response) => response.data.data)
  } catch (error) {
    return error
  }
}

export const assignLibrary = async (libraryId: string, clientId: string) => {
  try {
    return await getAxiosV2()
      .post(`${APIS.libraries}/${libraryId}/assignments`, {
        clientId,
      })
      .then((response) => response.data.data)
  } catch (error) {
    return error
  }
}

export const unassignLibrary = async (
  libraryId: string,
  assignmentId: string
) => {
  try {
    return await getAxiosV2()
      .delete(`${APIS.libraries}/${libraryId}/assignments/${assignmentId}`)
      .then((response) => response.data.data)
  } catch (error) {
    return error
  }
}
